import { NavItem, ParentNavItem } from '@shared/Frontend/components/navItems.layout'
import { fromJSX, Updater, Widget } from 'widgets-for-react'
import { CustomParsedNode } from '../../legacy/public_site/components/drupal/types_and_parser/extra_types.mod'
import { ParsedNode } from '../../legacy/public_site/components/drupal/types_and_parser/types.ext.gen'
import { SiteheaderLayout } from './siteheader.layout'
import { SiteheaderState } from './siteheader.state'
import React = require('react')

export const siteheaderWidget = (
  state: SiteheaderState,
  isDesktop: boolean,
  language: string,
  node: ParsedNode | CustomParsedNode | 'none'
): Widget<Updater<SiteheaderState>> =>
  fromJSX((setState) => (
    <SiteheaderLayout
      language={language}
      node={node}
      isMenuOpen={state.mode == 'open'}
      toggleMenu={() =>
        setState((state): SiteheaderState => ({ ...state, mode: state.mode == 'open' ? 'closed' : 'open' }))
      }
      items={
        state.navLinks.kind == 'loaded'
          ? state.navLinks.value.map(
              (item): ParentNavItem => ({
                title: item.label,
                url: item.url,
                isExternal: item.external,
                subNav: item.children
                  ? item.children.map(
                      (child): NavItem => ({
                        title: child.label,
                        url: child.url,
                        isExternal: child.external,
                        isActive: window.location.pathname.replace(/\/*$/, '') === child.url.replace(/\/*$/, '')
                      })
                    )
                  : undefined
              })
            )
          : []
      }
      isDesktop={isDesktop}
    />
  ))
